/** What an import bell entry says, read back from the title and text the import services send (in English). */
export interface ImportNotice {
  name: string;
  status: "DONE" | "PARTIAL" | "FAILED";
  created?: number;
  updated?: number;
  skipped?: number;
  archived?: boolean;
}

// Same wording in the ERP, waba and core-api ImportJobWorker / ImportNotifier.
const TITLE = /^(.*?)\s+(imported, some rows skipped|imported|import failed)$/;
const COUNTS = /^(\d+) added, (\d+) updated(?:, (\d+) not imported)?/;

export function importNotice(title: string | null | undefined, description: string | null | undefined): ImportNotice | null {
  const heading = TITLE.exec((title ?? "").trim());
  if (!heading) return null;
  const status = heading[2] === "imported" ? "DONE" : heading[2] === "import failed" ? "FAILED" : "PARTIAL";
  return { name: heading[1], status, ...importCounts(description) };
}

/** The counts of the bell text ("1 added, 300 updated, 3 not imported"), or why nothing was imported. */
export function importCounts(description: string | null | undefined): Omit<ImportNotice, "name" | "status"> {
  const text = (description ?? "").trim();
  const counts = COUNTS.exec(text);
  if (counts) return { created: +counts[1], updated: +counts[2], skipped: counts[3] ? +counts[3] : 0 };
  return /archived/i.test(text) ? { archived: true } : {};
}
